export default __webpack_public_path__ + "static/media/oscer-pres-dark-urine.11907fbb.svg";